import get from 'lodash/get';
import flow from 'lodash/flow';
import assign from 'lodash/assign';
import join from 'lodash/join';
import flattenDeep from 'lodash/flattenDeep';

const errorModel = {
  Status: null,
  StatusText: '',
  Code: '',
  Message: '',
  MessagePL: '',
  Errors: [],
  FlattenErrors: '',
  details: [] // For backward compatibility
};

export function makeErrorMessage(error = {}) {
  const model = assign({}, errorModel);

  return flow([
    getStatus,
    getStatusText,
    getCode,
    getMessage,
    getMessagePL,
    getErrors,
    getFlattenErrors,
    getDetails // For backward compatibility
  ])({
    ...model,
    ...error
  });
}

function getStatus(error) {
  return {
    ...error,
    Status: get(error, 'status')
  };
}

function getStatusText(error) {
  return {
    ...error,
    StatusText: get(error, 'data.Status') || get(error, 'data.error.status') || get(error, 'statusText', '')
  };
}

function getCode(error) {
  return {
    ...error,
    Code: get(error, 'data.Code')
  };
}

function getMessage(error) {
  return {
    ...error,
    Message: get(error, 'data.Message') || get(error, 'data.error.message', '')
  };
}

function getMessagePL(error) {
  return {
    ...error,
    MessagePL: get(error, 'data.MessagePL') || get(error, 'data.error.messagePL', '')
  };
}

function getErrors(error) {
  return {
    ...error,
    Errors: get(error, 'data.Errors', [])
  };
}

function getFlattenErrors(error) {
  return {
    ...error,
    FlattenErrors: join(
      flattenDeep([
        get(getMessagePL(error), 'MessagePL'),
        get(getErrors(error), 'Errors')
      ]), ' ')
  };
}

function getDetails(error) {
  return {
    ...error,
    details: get(error, 'data.error.details', [])
  };
}

